import { forwardRef } from "react";
import TopBarProgress from "react-topbar-progress-indicator";
import { Loader } from "@/components/ui/loader";
import { ScrollableChat, ScrollableChatRef } from "@/components/feature/chat";
import { OpenChatMessage } from "@/types/open-chat";
import { ChatMessage } from "./ChatMessage";
import { INITIAL_MESSAGE } from "../constants";

interface Props {
  messages: OpenChatMessage[];
  isLoading: boolean;
  isLoadingFirst: boolean;
  onImprovePrompt: () => void;
  onWebCitationClick?: (sourceIds: number[], messageId?: string) => void;
  onSourcesButtonClick?: (messageId?: string) => void;
}

export const MessageList = forwardRef<ScrollableChatRef, Props>(function MessageList(
  { messages, isLoading, isLoadingFirst, onImprovePrompt, onWebCitationClick, onSourcesButtonClick },
  ref,
) {
  return (
    <div className="min-h-0 flex-1 overflow-hidden">
      <ScrollableChat ref={ref} className="h-full p-6">
        {isLoadingFirst && <TopBarProgress />}

        <div className="flex flex-col gap-4">
          <ChatMessage message={INITIAL_MESSAGE} allowImprovement={false} allowCopy={false} />

          {messages.map(message => (
            <ChatMessage
              key={message.id}
              message={message}
              onImprovePrompt={onImprovePrompt}
              onWebCitationClick={onWebCitationClick}
              onSourcesButtonClick={onSourcesButtonClick}
              allowImprovement={true}
              allowCopy={true}
            />
          ))}

          {isLoading && <Loader />}
        </div>
      </ScrollableChat>
    </div>
  );
});
